import { Link, LinkProps } from '@mui/material';
import { colors } from '../../styles/theme/colors';

type InlineTextLinkProps = LinkProps;

export function InlineTextLink({ sx, children, ...props }: InlineTextLinkProps) {
    return (
        <Link
            sx={{
                color: colors.pink2,
                marginLeft: '0.5ch',
                ...sx,
            }}
            {...props}
        >
            {children}
        </Link>
    );
}
